import svgUrl from "ni:svgr;vJhV2Gd_c-Q9YV1SAJtZwYEd2HUj3nBVQOvbcul6C68";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const GroupMIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}><rect width={8} height={8} x={3} y={3} fill="var(--tbl--colors--icons--group--transformation)" rx={4} /><rect width={8} height={8} x={3} y={13} fill="var(--tbl--colors--icons--clean--primary)" rx={4} /><rect width={8} height={8} x={13} y={3} fill="var(--tbl--colors--icons--transformation--primary)" rx={4} /><rect width={8} height={8} x={13} y={13} fill="var(--tbl--colors--icons--group--clean)" rx={4} /></svg>;
const Memo = memo(GroupMIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "GroupMIcon";
}